import { Component, input, output } from '@angular/core';
import { GenericSectionContextualInfo } from '@shared/interfaces/generic-sections-contextual-info.interface';
import { IconButtonComponent } from '../icon-button/icon-button.component';
import { InfoButtonComponent } from '../info-button/info-button.component';
import { DashboardAlertComponent } from '../dashboard-alert/dashboard-alert.component';

@Component({
  selector: 'app-generic-section-header',
  templateUrl: 'generic-section-header.component.html',
  imports: [IconButtonComponent, InfoButtonComponent, DashboardAlertComponent],
})
export class GenericSectionHeaderComponent {
  public sectionTitle = input.required<string>();
  public infoButtonConfig = input<GenericSectionContextualInfo | null>(null);
  public showNoteButton = input.required<boolean>();
  public isSectionLocked = input(false);

  public noteClick = output<void>();
}
